import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const handleDownloadImage = async (
  tempLogoUrl: string,
  fileName: string
) => {
  try {
    // Handle both data URLs and regular URLs
    let blob;
    if (tempLogoUrl.startsWith('data:')) {
      // Convert data URL to blob
      const response = await fetch(tempLogoUrl);
      blob = await response.blob();
    } else {
      // Fetch image from URL
      const response = await fetch(tempLogoUrl);
      blob = await response.blob();
    }

    // Create download URL
    const downloadUrl = window.URL.createObjectURL(blob);

    // Create download link
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = `${fileName}.png`;

    // Trigger download
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error('Error downloading image:', error);
    // You might want to show an error message to the user here
  }
};

export const removeMarkdown = (content: string) => {
  return content.replace(/^```markdown\n|\n```$/g, '');
};
